import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/sections/service-page";
import { pageData } from "@/lib/service-page-data";
const data = pageData["api-integration"];
export const Route = createFileRoute("/services/api-integration")({
  component: () => <ServicePage data={data} />,
  head: () => ({
    meta: [
      { title: `${data.title} Services — CoderLity` },
      { name: "description", content: data.sub },
      { property: "og:title", content: `${data.title} Services — CoderLity` },
      { property: "og:description", content: data.sub },
      { property: "og:url", content: "/services/api-integration" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/services/api-integration" }],
  }),
});
